module.exports = new __parcel__URL__("tokenpocket.baf3cbdd.svg").toString();